import {useApi} from "@/lib/hook";
import {Select} from "@/theme/ui";

export const CategorySelect = ({optionsFilter, ...rest}) => {
    const {data} = useApi({
        route: {name: 'category.all'},
        setting: {
            select: (resp) => resp.categories.map((item)=>({
                value: item.id,
                label: item.name,
            })),
            staleTime: Infinity,
        }
    })

    const setOptions = () => {
        if (data && optionsFilter){
            return optionsFilter(data)
        }
        return data
    }

    return (
        <>
            <Select
                style={{
                    width: '100%',
                }}
                //fieldNames={{value: 'id', label: 'name'}}
                options={setOptions()}
                filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                {...rest}
            />
        </>
    );
}

